import { render } from "./CancelSectionOptions.vue?vue&type=template&id=2ecf9823&scoped=true&ts=true"
import script from "./CancelSectionOptions.vue?vue&type=script&lang=ts"
export * from "./CancelSectionOptions.vue?vue&type=script&lang=ts"

import "./CancelSectionOptions.vue?vue&type=style&index=0&id=2ecf9823&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecf9823"]])

export default __exports__